import React from 'react';
import UserEditForm from './user_edit_form';
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
import i18next from 'i18next';

import { PageTitle } from '../PageTitle';
import { Message } from '../Message';
import { UsersService, RolesService } from '../../services';
import { FormatHelper } from '../../helpers';

@connect(state => {
  return {
    me: state.user.me
  }
})
class UserEdit extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      added: null,
      user: null,
      availableRoles: null,
      userId: props.match.params.userId,
      errorMessage: null,
      localErrorMessage: null,
      localSuccessMessage: null,
      roleTypes: null,
      emailPreferences: null,
      smsPreferences: null,
    };
  }

  componentDidMount() {
    UsersService.get(this.state.userId).then((response) => {
      this.setState({
        user: response.user,
        emailPreferences: response.user.notificationPreferences.filter((preference) => preference.email != null).map((pref) => ({ email: pref.email, active: pref.active, id: pref.id })),
        smsPreferences: response.user.notificationPreferences.filter((preference) => preference.sms != null).map((pref) => ({ sms: pref.sms, active: pref.active, id: pref.id })),
        voicePreferences: response.user.notificationPreferences.filter((preference) => preference.voice != null).map((pref) => ({ voice: {number: pref.voice, sendVoicePrefix: pref.sendVoicePrefix}, active: pref.active, id: pref.id })),
      });
    }).catch((error) => {
      this.setState({ errorMessage: i18next.t('messages.could_not-load-user-edit') });
      console.error(error);
    });

    RolesService.listAll().then((response) => {
      this.setState({ availableRoles: response.roles });
    }).catch((error) => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-roles') });
      console.error(error);
    });

    RolesService.getAllRoleTypes().then((response) => {
      let roleTypes = response.roleTypes.filter(type => type.token != "responsibility_role")
      this.setState({ roleTypes: roleTypes });
    }).catch((error) => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-role-types') });
      console.error(error);
    });
  }

  handleSubmit(userData) {
    this.setState({localErrorMessage: null, localSuccessMessage: null});

    if (userData.button === "testNotificationPreferences") {
      return this.handleTestNotificationPreferences(userData);
    }

    let user = this.state.user;
    let userId = this.state.user.id;

    user.firstName = userData.firstName;
    user.lastName = userData.lastName;
    user.username = userData.username;
    user.password = userData.password ? userData.password : null;
    user.temperatureDisplayUnit = userData.temperatureDisplayUnit.value;
    user.locale = userData.locale.value;
    user.roles = [];
    
    this.state.roleTypes.forEach(type => {userData.roles[type.token].forEach(role => user.roles.push({id: role.value}))});

    let notificationPreferences  = FormatHelper.formatPhoneNumbers(userData.smsPreferences.filter((pref) => pref.sms && pref.sms !== ''))
      .concat(FormatHelper.formatPhoneNumbers(userData.voicePreferences.filter((pref) => pref.voice?.number && pref.voice?.number !== ''), "voice"))
      .concat(userData.emailPreferences.filter((pref) => pref.email && pref.email !== ''));

    console.log(notificationPreferences);

    let userDataHash = {
      user: user,
      notificationPreferences: notificationPreferences
    };

    UsersService.save(userId, userDataHash).then(user => {
      this.setState({ added: user });
    }).catch(error => {
      console.error(error);
      this.setState({ localErrorMessage: error.message });
    });
  }

  handleArchive() {
    if (this.props.me.id === this.state.user.id) {
      this.setState({localErrorMessage: i18next.t('messages.you-cannot-delete-yourself')});
    }
    else {
      UsersService.archive(this.state.userId).then(response => {
            this.setState({ deleted: true });
          }).catch(error => {
            console.error(error);
            this.setState({errorMessage: i18next.t('messages.error-deleting-user')});
          });
    }
  }

  messageDismissCallback() {
    this.setState({ localSuccessMessage: null, localErrorMessage: null });
  }

  renderMessages() {
    if (this.state.localErrorMessage || this.state.localSuccessMessage) {
      return (
          <Message  messages={{ state: { successMessage: this.state.localSuccessMessage } }} errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
      );
    }

    return null;
  }

  render() {
    if (this.state.errorMessage) {
      return (
          <Redirect to={{
            pathname: '/admin/users',
            state: {
              errorMessage: this.state.errorMessage
            }
          }}/>
      );
    }

    if (this.state.added) {
      return (
          <Redirect to={{
            pathname: '/admin/users',
            state: {
              from: this.props.location,
              successMessage: i18next.t('messages.user-saved')
            }
          }}/>
      );
    } else if (this.state.deleted) {
      return (
        <Redirect to={{
          pathname: '/admin/users',
          state: {
            from: this.props.location,
            successMessage: i18next.t('messages.user-deleted')
          }
        }}/>
      );
    } else {
      if (this.state.user && this.state.availableRoles && this.state.roleTypes) {
        const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
        const searchTerms = this.props.location.state && this.props.location.state.searchTerms ? this.props.location.state.searchTerms : null;
        return (
            <div>
              <div className="row">
                <PageTitle title={i18next.t('pages.users.edit-user')}
                           backLinkWithParams= {{
                             link: {
                               pathname: "/admin/users",
                               search: backLinkSearch,
                               state: { searchTerms: searchTerms }
                             }
                           }} />
              </div>
              {this.renderMessages()}
              <div className="op-content-box">
                <UserEditForm
                    user={this.state.user}
                    onSubmit={this.handleSubmit.bind(this)}
                    onArchive={this.handleArchive.bind(this)}
                    availableRoles={this.state.availableRoles}
                    roleTypes={this.state.roleTypes}
                    emailPreferences={this.state.emailPreferences}
                    smsPreferences={this.state.smsPreferences}
                    voicePreferences={this.state.voicePreferences}
                    backLinkWithParams= {{
                      link: {
                        pathname: "/admin/users",
                        search: backLinkSearch,
                        state: { searchTerms: searchTerms }
                      }
                    }}
                />
              </div>
            </div>
        );
      } else {
        return (
            <div className="loader">{i18next.t('loading')}</div>
        );
      }
    }

  }
}

export default UserEdit;
